<ng-container [formGroup]="formCiasFilter"> 
    <label class="container" *ngFor="let airline of availableAirlines; let i = index">
        <input type="checkbox" (click)="sendFilterOption(airline, i)" [value]="airline" [formControl]="ciasFilterArray.at(i)">
        <span class="checkmark"></span>
        {{airline.name}}
    </label>
</ng-container>